import type { DependencyList } from 'react'

import { useRef } from 'react'
import fastEq from 'fast-deep-equal'

const useCreation = <T>(factory: () => T, deps: DependencyList) => {
	const { current } = useRef({
		deps,
		obj: undefined as T,
		initialized: false,
	})
	if (current.initialized === false || !fastEq(current.deps, deps)) {
		current.deps = deps
		current.obj = factory()
		current.initialized = true
	}

	return current.obj
}

export default useCreation
